/* GOG – effetti home: fiamme "Preferirei di no" e specchio liquido Geminga */
(function () {
  'use strict';
  if (window.__gogFx) return; window.__gogFx = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Fiamme: come sul sito originale, un disegno alla volta ogni secondo */
  function flames() {
    Array.prototype.forEach.call(document.querySelectorAll('.flames'), function (box) {
      if (box.__gog) return; box.__gog = true;
      var imgs = box.querySelectorAll('img'), n = imgs.length, i = 0;
      if (!n) return;
      imgs[0].style.display = 'block';
      if (reduce || n < 2) return;
      setInterval(function () {
        imgs[i].style.display = 'none';
        i = i + 1 === n ? 1 : i + 1;
        imgs[i].style.display = 'block';
      }, 1000);
    });
  }

  /* Specchio liquido in bianco e nero, con il titolo in rilievo olografico */
  var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
  var FS = [
    'precision highp float;',
    'uniform vec2 uRes;uniform float uT;uniform vec2 uM;uniform float uK;uniform sampler2D uTx;uniform float uHas;',
    'float hash(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233)))*43758.5453);}',
    'vec2 warp(vec2 p){',
    '  vec2 d=p-uM;float r=dot(d,d);',
    '  p+=d*uK*.9*exp(-r*5.);',
    '  p+=uK*.12*vec2(sin(r*14.-uT*3.),cos(r*14.-uT*3.))*exp(-r*3.);',
    '  for(int i=1;i<6;i++){float f=float(i);',
    '    p.x+=.42/f*sin(f*1.7*p.y+uT*.35+f*1.3);',
    '    p.y+=.42/f*cos(f*1.5*p.x-uT*.28+f*2.1);}',
    '  return p;}',
    'float hgt(vec2 p){vec2 q=warp(p);float l=sin(q.x*1.6)+sin(q.y*1.6)+.5*sin((q.x+q.y)*1.1);',
    '  vec2 uv=p*min(uRes.x,uRes.y)/2.2/uRes+.5;float th=texture2D(uTx,uv).g*uHas;',
    '  return mix(l,l*.25,th)+th*.34;}',
    'void main(){',
    '  vec2 p=(gl_FragCoord.xy-.5*uRes)/min(uRes.x,uRes.y)*2.2;',
    '  float e=.012;float h=hgt(p);',
    '  vec3 n=normalize(vec3(hgt(p-vec2(e,0.))-hgt(p+vec2(e,0.)),hgt(p-vec2(0.,e))-hgt(p+vec2(0.,e)),e*9.));',
    '  vec3 r=reflect(vec3(0.,0.,-1.),n);',
    '  float band=.5+.5*sin(r.y*7.+r.x*3.+h*1.5);',
    '  float chrome=smoothstep(.05,.95,band);',
    '  float sp=pow(max(0.,dot(r,normalize(vec3(.3,.6,.75)))),40.);',
    '  float g=hash(floor(gl_FragCoord.xy)+floor(uT*12.)*17.);',
    '  float L=chrome+sp*.6;',
    '  float T=smoothstep(.30,.70,L+(g-.5)*.55);',
    '  float bw=mix(L,T,.62)+(g-.5)*.10;',
    '  vec3 c=vec3(mix(.20,1.,clamp(bw,0.,1.)));',
    '  float m=texture2D(uTx,gl_FragCoord.xy/uRes).r*uHas;',
    '  float fr=1.-n.z;',
    '  vec3 tx=vec3(.02+.50*pow(chrome,5.)+sp*1.1+smoothstep(.55,.95,fr)*.55)+(g-.5)*.06;',
    '  c=mix(c,tx,m);',
    '  gl_FragColor=vec4(c,1.);}'
  ].join('\n');

  function blur(a, w, h, r) {
    var b = new Float32Array(a.length), x, y, s, i, pass;
    for (pass = 0; pass < 2; pass++) {
      for (y = 0; y < h; y++) { s = 0; i = y * w;
        for (x = -r; x < w; x++) { if (x + r < w) s += a[i + x + r]; if (x - r - 1 >= 0) s -= a[i + x - r - 1]; if (x >= 0) b[i + x] = s / (2 * r + 1); } }
      for (x = 0; x < w; x++) { s = 0;
        for (y = -r; y < h; y++) { if (y + r < h) s += b[(y + r) * w + x]; if (y - r - 1 >= 0) s -= b[(y - r - 1) * w + x]; if (y >= 0) a[y * w + x] = s / (2 * r + 1); } }
    }
  }

  function Mirror(canvas) {
    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'low-power' });
    if (!gl) return false;
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(o)); return o; }
    var pr = gl.createProgram();
    gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) throw new Error('link');
    gl.useProgram(pr);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var U = function (n) { return gl.getUniformLocation(pr, n); };
    var uRes = U('uRes'), uT = U('uT'), uM = U('uM'), uK = U('uK'), uHas = U('uHas');
    gl.uniform1i(U('uTx'), 0);
    var tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    var host = canvas.parentNode, box = host.parentNode, title = box.querySelector('.cta h2');
    var w = 1, h = 1, scale = 1, has = 0, off = document.createElement('canvas');

    function relief() {
      has = 0;
      if (!title) return;
      var cr = canvas.getBoundingClientRect(), tr = title.getBoundingClientRect();
      if (!cr.width || !tr.width) return;
      var cs = getComputedStyle(title), fs = parseFloat(cs.fontSize) * (w / cr.width);
      var txt = (title.textContent || '').trim(); if (cs.textTransform === 'uppercase') txt = txt.toUpperCase();
      off.width = w; off.height = h;
      var c = off.getContext('2d', { willReadFrequently: true });
      c.fillStyle = '#000'; c.fillRect(0, 0, w, h);
      c.font = '900 ' + fs + 'px "Helvetica Neue", Helvetica, Arial, sans-serif';
      c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillStyle = c.strokeStyle = '#fff';
      c.lineJoin = 'round'; c.lineWidth = fs * 0.045;
      var cx = (tr.left + tr.width / 2 - cr.left) * (w / cr.width), cy = (tr.top + tr.height / 2 - cr.top) * (h / cr.height) + fs * 0.04;
      var mw = c.measureText(txt).width, fit = Math.min(1, (tr.width * (w / cr.width)) / (mw + c.lineWidth));
      c.translate(cx, cy); c.scale(fit, 1);
      c.strokeText(txt, 0, 0); c.fillText(txt, 0, 0);
      var id = c.getImageData(0, 0, w, h), d = id.data, a = new Float32Array(w * h), i;
      for (i = 0; i < a.length; i++) a[i] = d[i * 4];
      blur(a, w, h, Math.max(2, Math.round(fs * 0.022)));
      for (i = 0; i < a.length; i++) d[i * 4 + 1] = a[i];
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, id);
      has = 1; box.classList.add('gog-relief');
    }
    function size() {
      var cw = host.offsetWidth || 1, ch = host.offsetHeight || 1;
      scale = Math.min(window.devicePixelRatio || 1, 1.5) * (cw > 900 ? 0.8 : 0.9);
      w = canvas.width = Math.max(2, Math.round(cw * scale)); h = canvas.height = Math.max(2, Math.round(ch * scale));
      gl.viewport(0, 0, w, h);
      try { relief(); } catch (e) { has = 0; box.classList.remove('gog-relief'); }
      if (reduce) draw();
    }
    var tm = [0, 0], m = [0, 0], kT = 0, k = 0, visible = true, t0 = performance.now(), raf = 0;
    function point(e) {
      var r = canvas.getBoundingClientRect(); if (!r.width || !r.height) return;
      var x = (e.clientX - r.left) / r.width, y = 1 - (e.clientY - r.top) / r.height;
      if (x < 0 || x > 1 || y < 0 || y > 1) { kT = 0; return; }
      var mn = Math.min(w, h);
      tm[0] = (x * w - 0.5 * w) / mn * 2.2; tm[1] = (y * h - 0.5 * h) / mn * 2.2; kT = 1;
    }
    window.addEventListener('pointermove', point, { passive: true });
    window.addEventListener('pointerdown', point, { passive: true });
    document.addEventListener('pointerleave', function () { kT = 0; });
    var rz = 0; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(size, 150); });
    function draw() {
      m[0] += (tm[0] - m[0]) * 0.06; m[1] += (tm[1] - m[1]) * 0.06; k += (kT - k) * 0.04;
      gl.uniform2f(uRes, w, h); gl.uniform1f(uT, (performance.now() - t0) / 1000); gl.uniform2f(uM, m[0], m[1]); gl.uniform1f(uK, k); gl.uniform1f(uHas, has);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    function loop() { raf = 0; if (!visible) return; draw(); if (!reduce) raf = requestAnimationFrame(loop); }
    size(); loop();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
    window.addEventListener('load', size);
    if (window.IntersectionObserver) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible && !raf) loop(); }).observe(canvas);
    return true;
  }

  function mirrors() {
    Array.prototype.forEach.call(document.querySelectorAll('canvas.gog-mirror'), function (c) {
      if (c.__gog) return; c.__gog = true;
      var ok = false; try { ok = Mirror(c); } catch (e) { ok = false; }
      if (!ok) c.parentNode.classList.add('gog-mirror-fallback');
    });
  }
  function init() { flames(); mirrors(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
